// Carry Roll Spin-loft computation (9.6). Pure function.
// spin-loft = dynamicLoft − attackAngle; out-of-range flag.
const SPIN_LOFT_MIN = 4; // deg
const SPIN_LOFT_MAX = 70; // deg
/**
 * Compute spin-loft from dynamic loft and attack angle (9.6).
 * Flag out-of-range values that suggest data error or extreme delivery.
 */
export function computeSpinLoft(delivery) {
    if (delivery == null || delivery.dynamicLoftDeg == null || delivery.attackAngleDeg == null) {
        return null;
    }
    const spinLoftDeg = delivery.dynamicLoftDeg - delivery.attackAngleDeg;
    const outOfRange = spinLoftDeg < SPIN_LOFT_MIN || spinLoftDeg > SPIN_LOFT_MAX;
    let message;
    if (spinLoftDeg < SPIN_LOFT_MIN) {
        message = `Spin-loft ${spinLoftDeg.toFixed(1)}° is very low — check launch monitor data.`;
    }
    else if (spinLoftDeg > SPIN_LOFT_MAX) {
        message = `Spin-loft ${spinLoftDeg.toFixed(1)}° is very high — excessive spin likely.`;
    }
    else {
        message = `Spin-loft ${spinLoftDeg.toFixed(1)}° within expected range.`;
    }
    return {
        spinLoftDeg: Math.round(spinLoftDeg * 10) / 10,
        outOfRange,
        message,
    };
}
//# sourceMappingURL=spinLoft.js.map